<template>
    <div class="row mt-5">
        <div class="offset-md-3 col-md-6">
            <div class="bg-white p-3 shadow-sm rounded-lg">
                <div>
                    <Alerts :_success="success" :_error="error"></Alerts>

                    <h4 class="font-weight-bold mb-3">Verification Code</h4>
                    <div v-if="!code_sent" class="mb-4">
                        <p class="text-muted">How would you like to receive verification code?</p>

                        <div class="custom-control custom-switch">
                            <input type="radio" class="custom-control-input" v-model="channel" value="flock"
                                   id="channel-flock" :disabled="wait">
                            <label class="custom-control-label" for="channel-flock">
                                Send code to Flock channel &nbsp;
                                <a href="https://web.flock.com" target="_blank">(Go to flock)</a>
                            </label>
                        </div>
                        <div class="custom-control custom-switch">
                            <input type="radio" class="custom-control-input" v-model="channel" value="email"
                                   id="channel-email" :disabled="wait">
                            <label class="custom-control-label" for="channel-email">
                                Send reset link to my E-Mail &nbsp;
                                <a href="https://mail.google.com/" target="_blank">({{ user.email }})</a>
                            </label>
                        </div>

                        <div class="form-group mb-3 mt-4">
                            <button @click.prevent="sendCode()" class="btn btn-info">
                                <template v-if="wait">Please wait...</template>
                                <template v-else>Send verification code</template>
                            </button>
                            <Logout button="yes"></Logout>
                        </div>
                    </div>
                </div>

                <form v-if="code_sent" @submit.prevent="verify()">
                    <p class="text-muted">Verification code was sent to you {{ channel }}</p>

                    <div class="form-group mb-3">
                        <input id="code" type="number" class="form-control" required ref="code"
                               v-model="code" @keyup="trySubmitCode()" placeholder="Enter 6 digit verification code"
                               :disabled="wait">
                    </div>

                    <div class="form-group mb-3">
                        <button type="submit" class="btn btn-dark mr-2" :disabled="wait">
                            <template v-if="wait">Please wait...</template>
                            <template v-else>Verify Code</template>
                        </button>
                        <a href="#" @click="resendCode()" class="btn btn-outline-secondary">Did not receive code?</a>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Alerts from "@/components/Alerts";
import Logout from "@/components/Logout";

export default {
    name: "Verify",
    components: {Alerts, Logout},
    data() {
        return {
            code: '',
            channel: 'flock',
            code_sent: false
        }
    },
    computed: {
        user() {
            return JSON.parse(localStorage.getItem('user'))
        }
    },
    methods: {
        resendCode() {
            this.code_sent = false
        },
        trySubmitCode() {
            if (this.code.length >= 6) {
                this.verify()
            }
        },
        sendCode() {
            this.setLoading()
            this.clear()
            this.success = "Sending code to your Flock channel, please wait..."
            this.$http.post('/verify/resend', {channel: this.channel}).then(() => {
                this.code_sent = true
                this.success = `Verification code has been sent to your ${this.channel}!`
            }).catch(error => {
                this.showError(error)
            }).then(() => {
                this.wait = false
            })
        },
        verify() {
            this.setLoading()
            this.clear()
            this.success = "Verifying your code, please wait..."
            this.$http.post('/verify/phone', {code: this.code}).then(() => {
                this.success = "Verification successful! Redirecting to your dashboard!"
                setTimeout(() => (this.$router.push('/home')), 500)
            }).catch(error => {
                this.showError(error)
            }).then(() => {
                this.wait = false
            })
        }
    }
}
</script>

<style scoped>

</style>